import { FC } from 'react';
import styled from 'styled-components';

import { TermsConfig } from '#/service/config/common.types';
import { ButtonVariant, FormFactors } from '#/service/constants';
import { tb } from '#/store/translation/translation.store';

import { Button } from '../Button/Button';
import { FullPageModal } from '../Modal/FullPageModal';
import { Modal } from '../Modal/Modal';
import { Terms } from './Terms';
import { useTermsModal } from './TermsModal.hook';

interface Props {
  isAppReady: boolean;
}

interface ModalContentsProps {
  formFactor: FormFactors;
  termsBody: TermsConfig['body'];
  onClick: () => void;
}

export const TermsModal: FC<Props> = ({ isAppReady }) => {
  const { terms, showTerms, acceptTerms, formFactor } =
    useTermsModal(isAppReady);

  if (formFactor === FormFactors.DESKTOP) {
    return (
      <Modal isOpen={showTerms} showCloseButton={false}>
        <ModalContents
          formFactor={formFactor}
          onClick={acceptTerms}
          termsBody={terms.body}
        />
      </Modal>
    );
  }

  if (showTerms) {
    return (
      <StyledModal>
        <div>
          <ModalContents
            formFactor={formFactor}
            onClick={acceptTerms}
            termsBody={terms.body}
          />
        </div>
      </StyledModal>
    );
  }

  return null;
};

const ModalContents: FC<ModalContentsProps> = ({
  formFactor,
  termsBody,
  onClick,
}) => (
  <>
    <Terms formFactor={formFactor} termsBody={termsBody} />
    <Button onClick={onClick} variant={ButtonVariant.Primary}>
      {tb('button.accept')}
    </Button>
  </>
);

const StyledModal = styled(FullPageModal)`
  align-items: center;
`;
